import React, {useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../api';

export default function TimesheetDetail() {
  const {id} = useParams();
  const [timesheet, setTimesheet] = useState(null);
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    api(`/timesheets/timesheets/${id}`).then(r => r.ok ? r.json() : null).then(setTimesheet).catch(() => {});
    api(`/timesheets/timesheets/${id}/entries`).then(r => r.ok ? r.json() : []).then(e => setEntries(e.sort((a, b) => b.date.localeCompare(a.date)))).catch(() => {});
  }, [id]);

  if (!timesheet) return <Layout><div className="text-center py-12 text-gray-500">Loading...</div></Layout>;

  const formatTime = (iso) => {
    if (!iso) return '—';
    return new Date(iso).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
  };

  return (
    <Layout>
      <div className="mb-6">
        <Link to="/timesheets" className="text-indigo-600 hover:text-indigo-800 text-sm">← Back to Timesheets</Link>
      </div>

      <div className="bg-white rounded-lg shadow p-6 mb-6">
        <h2 className="text-xl font-bold text-gray-900 mb-2">{timesheet.startDate} — {timesheet.endDate}</h2>
        <span className={`inline-flex px-2 py-1 rounded text-xs font-medium ${
          timesheet.status === 'APPROVED' ? 'bg-green-50 text-green-700' :
          timesheet.status === 'SUBMITTED' ? 'bg-blue-50 text-blue-700' :
          'bg-gray-100 text-gray-600'
        }`}>{timesheet.status}</span>
      </div>

      <div className="bg-white rounded-lg shadow overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Start</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">End</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Hours</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Description</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {entries.map(entry => (
              <tr key={entry.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 text-gray-900">{entry.date}</td>
                <td className="px-6 py-4 text-gray-600">{formatTime(entry.startAt)}</td>
                <td className="px-6 py-4 text-gray-600">{formatTime(entry.endAt)}</td>
                <td className="px-6 py-4 text-gray-900 font-medium">{entry.totalHours != null ? Number(entry.totalHours).toFixed(2) : '—'}</td>
                <td className="px-6 py-4 text-gray-600">{entry.description || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {entries.length === 0 && <div className="text-center py-12 text-gray-500">No entries found.</div>}
      </div>
    </Layout>
  );
}
